import { apiRequest } from "./client";

/** The signed-in account's privacy choices on the server. */
export interface AccountPrivacy {
  /** Product analytics from devices, granted for this account. */
  analytics: boolean;
  /** Account usage data on the server; false once the account opted out. */
  usage_data: boolean;
}

interface PrivacyResponse {
  status: "success";
  data: AccountPrivacy;
}

const PRIVACY_URL = "/api/v1/auth/privacy/";

export async function getAccountPrivacy(): Promise<AccountPrivacy> {
  const result = await apiRequest<PrivacyResponse>(PRIVACY_URL, {
    silent: true,
  });
  return result.data;
}

export async function updateAccountPrivacy(
  changes: Partial<AccountPrivacy>,
): Promise<AccountPrivacy> {
  const result = await apiRequest<PrivacyResponse>(PRIVACY_URL, {
    method: "PUT",
    body: changes,
    silent: true,
  });
  return result.data;
}
